import { render, staticRenderFns } from "./annualEducationPlanDetail.vue?vue&type=template&id=236bf5eb"
import script from "./annualEducationPlanDetail.vue?vue&type=script&lang=js"
export * from "./annualEducationPlanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236bf5eb')) {
      api.createRecord('236bf5eb', component.options)
    } else {
      api.reload('236bf5eb', component.options)
    }
    module.hot.accept("./annualEducationPlanDetail.vue?vue&type=template&id=236bf5eb", function () {
      api.rerender('236bf5eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/annual/annualEducationPlanDetail.vue"
export default component.exports